export class UtilityAI {
    constructor(context, rootSelector, updatePeriod = 0.2) {
        this._rootReasoner = rootSelector;
        this._context = context;
        this.updatePeriod = this._elapsedTime = updatePeriod;
    }
    tick(deltaTime) {
        this._elapsedTime -= deltaTime;
        while (this._elapsedTime <= 0) {
            this._elapsedTime += this.updatePeriod;
            let action = this._rootReasoner.select(this._context);
            if (action != null)
                action.execute(this._context);
        }
    }
}
//# sourceMappingURL=UtilityAI.js.map